import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'
import * as action from '../action_x.js'
import { ctrlButton } from '../ui.js'

const type = 'EA_SHARINGPROPS'
const onSharingProps = object(listener, {
  type,
  passive,
  task: (
    element,
    event
  ) => {
    const { active, force_stop, session, sharer } = event.detail
    const controls = one(`.${elements.meet_controls}`, element)

    if (controls) {
      const shareScreenButton = ctrlButton('shareScreen', element)
      const shareScreenOffButton = ctrlButton('shareScreenOff', element)
      const extendedFeatures = getComputedStyle(controls).getPropertyValue('--ea_chat_meet_controls_extended_features')

      if (active) {
        if (extendedFeatures === 'true') {
          shareScreenButton.classList.add(utilities.modifiers.display.none)
          shareScreenOffButton.classList.remove(utilities.modifiers.display.none)
        }

        action.shareStart(sharer)
        ea_rainbow_attachvideo('conferenceSharingPip', session)
      } else {
        if (extendedFeatures === 'true') {
          shareScreenButton.classList.remove(utilities.modifiers.display.none)
          shareScreenOffButton.classList.add(utilities.modifiers.display.none)
        }

        action.shareStop(sharer)
      }
    }

    if (force_stop) {
      action.stream('screen', 1)
    }
  }
})

export default element => {
  onSharingProps.listen(element)
}
